import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

function PageTitle({ pageTitle, numberOfData }) {
  const navigate = useNavigate();
  const handleBackButtonClick = () => {
    navigate(-1);
  };
  return (
    <div className="backBtn">
      <ChevronLeft
        color="white"
        size="30"
        onClick={handleBackButtonClick}
        className="cursor-pointer"
      />
      <h2 className="text-lg text-white font-figtree max-lg:text-sm">
        {pageTitle}{" "}
        {numberOfData ? (
          <span className="text-sm max-lg:text-xs">
            ({numberOfData > 0 ? numberOfData : 0})
          </span>
        ) : (
          ""
        )}
      </h2>
    </div>
  );
}

export default PageTitle;
